import { create } from 'zustand'
import { getFixedAssetNavStatus } from '@/services/fixedAssets'

interface FixedAssetsNavState {
  allocateIncompleteCount: number
  setAllocateIncompleteCount: (count: number) => void
  fetchNavStatus: (opts?: { refresh?: boolean }) => Promise<void>
}

export const useFixedAssetsNavStore = create<FixedAssetsNavState>((set) => ({
  allocateIncompleteCount: 0,
  setAllocateIncompleteCount: (count) => set({ allocateIncompleteCount: count }),
  fetchNavStatus: async (opts) => {
    try {
      const status = await getFixedAssetNavStatus(opts)
      set({ allocateIncompleteCount: status.allocate_incomplete_count })
    } catch (err) {
      console.error('Failed to fetch Fixed Assets nav status:', err)
    }
  },
}))
